import { render } from "./g-navigation.vue?vue&type=template&id=b4efefec&ts=true"
import script from "./g-navigation.vue?vue&type=script&lang=tsx"
export * from "./g-navigation.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__